export const parsePhone = (value = ''): string => value.replace(/[^0-9+]/g, '');
